"use strict"

import angular from "angular"

angular.module("uCountitUiApp").directive("ucOnVisible", ($timeout) => ({
  restrict: "A",
  link(scope, element, attrs) {
    let didRun = false
    let observer = null

    const runOnce = () => {
      if (didRun) {
        return
      }
      didRun = true
      scope.$evalAsync(attrs.ucOnVisible)
      if (observer) {
        observer.disconnect()
        observer = null
      }
    }

    if (typeof window !== "undefined" && window.IntersectionObserver) {
      observer = new window.IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              runOnce()
              break
            }
          }
        },
        {
          root: null,
          rootMargin: "200px 0px",
          threshold: 0.01,
        }
      )

      observer.observe(element[0])
    } else {
      $timeout(runOnce, 0, false)
    }

    scope.$on("$destroy", () => {
      if (observer) {
        observer.disconnect()
        observer = null
      }
    })
  },
}))
